// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xNKU","col":"styles_col__pRjYw"};